import InvalidPage from './auth/InvalidPage';

export default function InvalidLink() {
    return (
        <div className="flex justify-center items-center h-[100vh] w-full">
            <div>
                <InvalidPage hiddenBtn />
            </div>
        </div>
    );
}
